import React from 'react'
import PropTypes from 'prop-types'
import { thousands } from '../../helpers/format_number'

class CurrencyBase extends React.PureComponent {
    static propTypes = {
        /**
         * Any node, if value is number component format it with ```format_number#thousands``` function
         */
        value: PropTypes.node,
        size: PropTypes.oneOf(['small', 'large']),
        iconPosition: PropTypes.oneOf(['before', 'after']),
        isDisabled: PropTypes.bool,
        isNotEnough: PropTypes.bool,
        tooltipId: PropTypes.string,
        mixClassName: PropTypes.string,
    }

    static defaultProps = {
        size: 'small',
        iconPosition: 'before',
        isNotEnough: false,
    }

    getClassNames = () => {
        return null
    }

    render() {
        const classNameBase = this.getClassNames()
        const { value, tooltipId = null } = this.props
        const dataAttrs = tooltipId ? {
            'data-tip': true,
            'data-for': tooltipId,
        } : {}
        // if it is number reformat it, otherwise show as it is
        const formattedValue = Number(value) === value ? thousands(value) : value

        return (
            <span className={classNameBase} {...dataAttrs}>
                {formattedValue}
            </span>
        )
    }
}

export default CurrencyBase



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/CurrencyBase/CurrencyBase.jsx